import React from 'react';
// @ts-ignore
import { connect as originConnect } from 'react-redux';
import type { IDispatch, IState } from './interface';

type hookType = (props: any) => JSX.Element | null;

export default function connect<P = {}>(
    container: React.ComponentClass<any> | hookType,
    parentReducerName?: string,
    extendReducerName?: string[],
) {
    const mapStateToProps = (state: IState, _props: P) => {
        let newState: Partial<IState> = {};
        if (parentReducerName) {
            newState = {
                pageData: state.pageData,
            };
            newState[parentReducerName] = state[parentReducerName];
        } else {
            newState = Object.assign({}, state);
        }
        if (extendReducerName && !!extendReducerName.length) {
            extendReducerName.forEach((name) => {
                if (state[name]) {
                    newState[name] = state[name];
                }
            });
        }
        return newState;
    };

    const mapDispatchToProps = (dispatch: IDispatch) => {
        return () => {
            const action = {
                type: 'DEFAULT',
                payload: {},
            };
            dispatch(action);
            return action;
        };
    };

    return originConnect(mapStateToProps, mapDispatchToProps)(container);
}
